/* eslint-disable max-classes-per-file */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var IncorrectLengthError = /** @class */ (function (_super) {
    __extends(IncorrectLengthError, _super);
    function IncorrectLengthError(expected, actual) {
        var _this = _super.call(this, 'ssn provided has wrong size') || this;
        _this.expected = expected;
        _this.actual = actual;
        // Set the prototype explicitly. Thx Microsoft!
        Object.setPrototypeOf(_this, IncorrectLengthError.prototype);
        return _this;
    }
    return IncorrectLengthError;
}(Error));
export { IncorrectLengthError };
var InvalidControlKeyError = /** @class */ (function (_super) {
    __extends(InvalidControlKeyError, _super);
    function InvalidControlKeyError(controlKey, ssn) {
        var _this = this;
        var msg = "controlKey \"".concat(controlKey, "\" does not match ssn \"").concat(ssn, "\"");
        _this = _super.call(this, msg) || this;
        _this.controlKey = controlKey;
        _this.ssn = ssn;
        // Set the prototype explicitly. Thx Microsoft!
        Object.setPrototypeOf(_this, InvalidControlKeyError.prototype);
        return _this;
    }
    return InvalidControlKeyError;
}(Error));
export { InvalidControlKeyError };
var InvalidSsnFormatError = /** @class */ (function (_super) {
    __extends(InvalidSsnFormatError, _super);
    function InvalidSsnFormatError() {
        var _this = _super.call(this, 'security social number is invalid') || this;
        // Set the prototype explicitly. Thx Microsoft!
        Object.setPrototypeOf(_this, InvalidSsnFormatError.prototype);
        return _this;
    }
    return InvalidSsnFormatError;
}(Error));
export { InvalidSsnFormatError };
var ControlKeyMismatchError = /** @class */ (function (_super) {
    __extends(ControlKeyMismatchError, _super);
    function ControlKeyMismatchError(expected, actual) {
        var _this = _super.call(this, 'control key does not check') || this;
        _this.expected = expected;
        _this.actual = actual;
        // Set the prototype explicitly. Thx Microsoft!
        Object.setPrototypeOf(_this, ControlKeyMismatchError.prototype);
        return _this;
    }
    return ControlKeyMismatchError;
}(Error));
export { ControlKeyMismatchError };
